/** Normalize to YYYY-MM-DD for stable filenames. */
function toYmd(isoOrDate: string): string {
  const s = (isoOrDate || '').trim();
  if (!s) return 'unknown';
  const d = s.slice(0, 10);
  if (/^\d{4}-\d{2}-\d{2}$/.test(d)) return d;
  const cleaned = s.replace(/[^\d-]/g, '').slice(0, 10);
  return cleaned || 'unknown';
}

/** Segment for export filenames, e.g. `from_2026-04-01_to_2026-04-20`. */
export function bandwidthExportDateFileSuffix(dateFrom: string, dateTo: string): string {
  return `from_${toYmd(dateFrom)}_to_${toYmd(dateTo)}`;
}
